import React from 'react';
import { Box } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import { token } from '@atlaskit/tokens';
import LockIcon from '@atlaskit/icon/glyph/lock';
import { EditSoldToAddressDisabledMessage } from '@css-xp/ppc-common';

export const SoldToAddressDisabledTooltip = () => {
  return (
    <Box paddingInlineStart="space.050">
      <Tooltip testId="sold-to-address-edit-disabled-tooltip" content={<EditSoldToAddressDisabledMessage />}>
        <LockIcon label="lock-icon" size="medium" testId="lock-icon" primaryColor={token('color.icon')} />
      </Tooltip>
    </Box>
  );
};
